import React, { Component } from 'react'
import Select from 'react-dropdown-select';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SimpleReactValidator from 'simple-react-validator';
import {submitFormData} from '../../actions/registrationForms'
import { toast } from 'react-toastify';

class regForm extends Component {
    constructor() {
        super()
        this.state = {
            regi_name : '',
            regi_mail : '',
            regi_address : '',
            regi_city : '',
            regi_own : '',
            regi_age : '',
            regi_state : '',
            regi_pincode : '',
            regi_mobile : '',
            regi_best_time : '',
            regi_category : '',
                    }
                    this.validator=new SimpleReactValidator()
                    this.handleSubmit = this.handleSubmit.bind(this)
    }
    handleSubmit = (event) => {

        event.preventDefault();
        if (this.validator.allValid()) {
            const {connection_id} = this.props 
            const options = {
                connection_id:connection_id,
                name:this.state.regi_name,
                email:this.state.regi_mail,
                city:this.state.regi_city,
                state:this.state.regi_state,
                subject:'',
                message:''
             }
    
            this.props.submitFormData(options)
        
            
            setTimeout(function(){
               
                    toast.success(" Successful submitted");
                    this.props.history.goBack()
                
            }, 500);
           

        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    handleChange(event) {
      
        this.setState({ [event.target.id]: event.target.value });
    }
    render() {
        return (
            <div>
                <div className="breadcrumb-section" style={{
                    background: 'var(--theme-color)',
                    color: 'white'
                }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="page-title" style={{ display: 'block', textAlignLast: 'center' }}>
                                    <div style={{ fontSize: 15, padding: 5 }}>Home</div>
                                    <h2 style={{ fontSize: 22, color: 'white' }} >Registration</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <section>
                    <div className='container enquery-form registration-form'>

                        <form onSubmit={(event) => this.handleSubmit(event)}>
                           <div className='row'>
                           <div className="row">
         
         <div className='col-md-6'>
             <label>Name*</label>
             <input id='regi_name' type='text' onChange={(e) => this.handleChange(e)}  />
             {this.validator.message('Name',this.state.regi_name,'required|alpha_space')}
         </div>
         <div className='col-md-6'>
             <label>Number of Bicycles already owned</label>
             <input id='regi_own' type='text' onChange={(e) => this.handleChange(e)} />
             {this.validator.message('Already Owned',this.state.regi_own,'required|alpha_space')}
         </div>
         <div className='col-md-6'>
             <label>Email*</label>
             <input id='regi_mail' type='text' onChange={(e) => this.handleChange(e)} />
             {this.validator.message('Mail',this.state.regi_mail,'required|email')}
         </div>
         <div className='col-md-6'>
         <div className='row'>
             <div className='col-6'>
                 <div>
                     <label>Age</label>
             <input type="number" name="test_name" min="1" oninput="validity.valid||(value='');"/>
                 </div>
             </div>
             <div className='col-6'>
                 <label>Sex</label><br/>
                 <input id='sex' name='sex' type='radio' style={{width:'10%',height:14}} onChange={(e) => this.handleChange(e)} value='Male' />Male
                 <input id='sex' name='sex' type='radio'style={{width:'10%',height:14}}  onChange={(e) => this.handleChange(e)} value='Female' />Female

             </div>
         </div>
         </div>
         <div className='col-md-6'>
             <label>Address</label>
             <textarea id='regi_address' onChange={(e) => this.handleChange(e)}></textarea>
             {this.validator.message('Adress',this.state.regi_address,'required|alpha_space')}
         </div>
         <div className='col-md-6'></div>
         <div className='col-md-6'>
             <label>State</label>
             <input id='regi_state' type='text' onChange={(e) => this.handleChange(e)} />
             {this.validator.message('State',this.state.regi_state,'required|alpha_space')}
         </div>
         <div className='col-md-6'>
             <label>City</label>
             <input id='regi_city' type='text' onChange={(e) => this.handleChange(e)} />
             {this.validator.message('City',this.state.regi_city,'required|alpha_space')}
         </div>
         <div className='col-md-6'>
             <label>Pincode</label>
             <input id='regi_pincode' type='text' onChange={(e) => this.handleChange(e)} />
             {this.validator.message('Pindcode',this.state.regi_pincode,'required|number')}
         </div>
         <div className='col-md-6'>
             <label>Mobile No</label>
             <input id='regi_mobile' type='text' onChange={(e) => this.handleChange(e)} />
             {this.validator.message('Mobile',this.state.regi_mobile,'required|phone')}
         </div>

         <div className='col-md-6'>
             <label>Select your competition catagory</label>
             <Select></Select>
         </div>
         <div className='col-md-6'>
             <label>Best Time</label>
             <input id='regi_best_time' type='text' onChange={(e) => this.handleChange(e)} />
             {this.validator.message('Time',this.state.regi_best_time,'required|alpha_numeric')}
         </div>




    
     
 </div>
                                
                            
                            
                            
                            </div>
                            <hr />
        <div className='row'>
            <div className='col-md-6'>
                <div className='row'>
            <div className='col-sm-12'>
                    <label>Total No. of experience in Professional cycling (in years)</label>
                    <input style={{width:'35%'}} type="number" id='regi_year' min="0" oninput="validity.valid||(value='');" onChange={(e)=>this.handleChange(e)}/>&nbsp;&nbsp;Years
</div> 
                </div>
                </div>
                </div>
                <div className='col-md-12'><div style={{padding:10}}>
                                    
                                <button className='btn btn-solid'>SUBMIT</button></div></div>
                        </form>
                    </div>
                </section>
            </div>
        )
    }
}
// const mapStateToProps = (state)=>({

//    // connection_id : state.tenant.connection_id
// })
// const mapDispatchToProps = (dispatch)=>
//     bindActionCreators(
//     dispatch
//     )


// export default connect (mapDispatchToProps,mapStateToProps)(withRouter(regEnquery))


const mapStateToProps = (state) => ({
    connection_id: state.tenant.connection_id,
    isAuth: state.user.isAuth,
    error: state.user.error,
});
const mapDispatchToProps = (dispatch) => {
    bindActionCreators( {submitFormData},
        dispatch)
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(regForm))